const CSV_FORMULA_PREFIX = /^[\t\r\n ]*[=+\-@]/;

export const escapeCsvValue = (value) => {
  let text = value == null ? '' : String(value);

  // Spreadsheet applications can execute cells beginning with these characters
  // as formulas. Prefixing with an apostrophe forces the value to remain text.
  if (CSV_FORMULA_PREFIX.test(text)) {
    text = `'${text}`;
  }

  const escaped = text.replace(/"/g, '""');
  return /[",\r\n]/.test(escaped) ? `"${escaped}"` : escaped;
};

export const downloadTextFile = ({ content, fileName, mimeType, includeBom = false }) => {
  const parts = includeBom ? ['\uFEFF', content] : [content];
  const blob = new Blob(parts, { type: mimeType });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = fileName;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();

  window.setTimeout(() => window.URL.revokeObjectURL(url), 1_000);
};

export const openPrintableReport = (html) => {
  const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const reportWindow = window.open(url, '_blank', 'noopener,noreferrer');

  // Keep the URL alive long enough for slower browsers to finish loading it.
  window.setTimeout(() => window.URL.revokeObjectURL(url), 60_000);

  return Boolean(reportWindow);
};
